<!-- 课程列表 -->

<template>
  <div class="main">
    <!-- 顶部搜索 -->
    <div class="s_wrapper">
      <el-select v-model="shelfStatus" placeholder="选择上下架状态" @change="onSearch" clearable>
        <el-option v-for="item in shelfOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-input class="s_input" placeholder="搜索课程名称" suffix-icon="el-icon-search" v-model="courseName" :clearable="true"
        @change="onSearch"></el-input>
      <el-cascader :options="cascaderOptions" placeholder="选择分类" v-model="categoryIds" @change="onSearch"
        :props="cascaderprops" collapse-tags clearable></el-cascader>
      <el-button class="btn" type="primary" @click="handleApply(1)">新增课程</el-button>
    </div>
    <div class="globle_border" v-loading="loading">
      <!-- 表格 -->
      <div class="g_table">
        <el-table :data="tableData" style="width: 100%" max-height="540">
          <el-table-column label="序号" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column min-width="210" show-overflow-tooltip prop="courseName" label="课程名称"></el-table-column>
          <el-table-column min-width="270" show-overflow-tooltip prop="categoryName" label="课程分类"></el-table-column>
          <el-table-column min-width="130" show-overflow-tooltip prop="price" label="课程价格(元)">
            <template slot-scope="scope">
              <span>{{ scope.row.costAttr == 0 ? "免费" : scope.row.price }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="130" show-overflow-tooltip prop="effectiveDay" label="购买有效期(天)">
            <template slot-scope="scope">
              <span v-if="scope.row.effectiveDay">{{ scope.row.effectiveDay }}</span>
              <span v-else>不限</span>
            </template>
          </el-table-column>
          <el-table-column min-width="130" show-overflow-tooltip prop="buyerCount" label="购买人数"></el-table-column>
          <el-table-column min-width="130" show-overflow-tooltip prop="teacherName" label="课程专家"></el-table-column>
          <el-table-column min-width="160" show-overflow-tooltip prop="virtualCount" label="虚拟购买人数"></el-table-column>
          <el-table-column min-width="180" show-overflow-tooltip prop="createdTime" label="发布时间"></el-table-column>
          <el-table-column min-width="140" show-overflow-tooltip prop="sort" label="排序"></el-table-column>
          <el-table-column min-width="160" show-overflow-tooltip label="课程标签">
            <template slot-scope="scope">
              <span v-if="scope.row.courseLabel == 0">无</span>
              <span v-if="scope.row.courseLabel == 1">最新</span>
              <span v-if="scope.row.courseLabel == 2">热门</span>
              <span v-if="scope.row.courseLabel == 3">推荐</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="是否推荐" header-align="center" align="center" min-width="100">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.switch" inactive-color="#E2E2E2"
                @change="changeStatus(scope.row)"></el-switch>
            </template>
          </el-table-column> -->
          <el-table-column label="上下架状态" header-align="center" align="center" min-width="100">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.onlineStatus" inactive-color="#E2E2E2"
                @change="changeOnlineStatus(scope.row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center" width="550" min-width="550" fixed="right">
            <template slot-scope="scope">
              <el-button size="small" class="btn" type="primary" plain @click="handleCheck(scope.row)">课时管理</el-button>
              <el-button size="small" class="btn" type="primary" plain @click="handleBuy(scope.row)">已购用户</el-button>
              <el-button size="small" class="btn" type="primary" plain
                @click="handleModify(scope.row)">修改虚拟在学人数</el-button>
              <el-button size="small" class="btn" type="primary" plain @click="handleApply(scope.row)">编辑</el-button>
              <!-- <el-button size="small" class="btn" type="primary" plain @click="handleView(scope.row)">查看</el-button> -->
              <el-button size="small" class="btn" type="danger" plain @click="handleDelete(scope.row)">删除</el-button>
              <el-button size="small" class="btn" type="primary" plain @click="handleAfter(scope.row)">课后问答</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
        layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>
    </div>

    <el-dialog title="修改虚拟在学人数" :visible.sync="dialogVisible" @close="handleCloseDialog">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="200px" class="demo-ruleForm">
        <el-row class="row">
          <el-col :span="24">
            <el-form-item label="虚拟在学人数：" prop="virtualCount">
              <el-input v-model="ruleForm.virtualCount" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCloseDialog" type="primary" plain>取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      shelfStatus: "", // 选择上下架状态
      shelfOptions: [{
        value: "1",
        label: "上架",
      },
      {
        value: "0",
        label: "下架",
      },
      ],
      courseName: "",
      categoryIds: "",
      cascaderOptions: [],
      cascaderprops: {
        checkStrictly: false,
        emitPath: false,
        multiple: true,
        value: "id",
        label: "categoryName",
        children: "children",
      },
      // 表格数据
      tableData: [],
      // 分页
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）

      // 弹窗数据
      dialogVisible: false, // 弹窗显隐
      ruleForm: {
        virtualCount: '',
        id: '',
      },
      rules: {
        virtualCount: [{ required: true, message: '请输入虚拟在学人数', trigger: 'blur' }, {
          pattern: /^\d+$/,  // 只允许整数
          message: '只能输入整数',
          trigger: 'blur'
        }]
      },
    }
  },
  created() {
    this.selectCourseInfoPage()
    this.getCategoryList()
  },
  methods: {
    // 获取列表
    selectCourseInfoPage() {
      this.loading = true
      this.$axios
        .post(this.$api.selectCourseInfoPage, {
          categoryIdList: this.categoryIds.length == 0 ? null : this.categoryIds,
          courseName: this.courseName || null,
          onlineStatus: this.shelfStatus,
          page: this.currentPage,
          pageSize: this.pageSize,
        })
        .then(res => {
          if (res.code == 100) {
            this.tableData =
              res.result.list.map(e => {
                return {
                  ...e,
                  switch: e.recommendFlag == 1 ? true : false,
                  onlineStatus: e.onlineStatus == 1 ? true : false,
                }
              }) || []
            this.totalItemsCount = res.result.totalCount
            this.loading = false
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    // 修改
    handleModify(row) {
      this.dialogVisible = true;
      this.$set(this.ruleForm, 'virtualCount', row.virtualCount)
      this.$set(this.ruleForm, 'id', row.id)
    },
    // 关闭弹窗
    handleCloseDialog() {
      this.dialogVisible = false;
      this.resetForm();
    },
    // 表单校验
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          console.log('error submit!!');
          return false;
        } else {
          this.$axios.post(this.$api.updateVirtualCount, {
            virtualCount: this.ruleForm.virtualCount,
            id: this.ruleForm.id,
          }).then((res) => {
            if (res.code == 100) {
              this.$message.success(res.desc);
              this.handleCloseDialog();
              this.selectCourseInfoPage();
            }
          }).catch(err => {
            this.$message({
              message: err.desc,
              type: "error",
            })
          })
        }
        this.handleCloseDialog();
      });
    },
    // 重置表单
    resetForm() {
      this.ruleForm = {};
      this.$refs.ruleForm.resetFields();
    },
    // 分类选择
    getCategoryList() {
      this.$axios
        .get(this.$api.getCategoryListSelect)
        .then(res => {
          if (res.code == 100) {
            this.cascaderOptions = this.processCategoryData(res.result)
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    processCategoryData(data) {
      function processItems(items, level) {
        for (let item of items) {
          if (level === 3) {
            delete item.children
          } else if (item.children && item.children.length > 0) {
            processItems(item.children, level + 1)
          }
        }
      }
      const processedData = JSON.parse(JSON.stringify(data))
      processItems(processedData, 1) // 从第一层开始处理
      return processedData
    },
    // 是否推荐
    changeStatus(row) {
      const originalSwitch = row.switch
      this.$confirm(`确定${row.switch ? "开启" : "关闭"}推荐吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(this.$api.updateRecommendFlag, {
              id: row.id,
              recommendFlag: row.switch ? 1 : 0,
            })
            .then(res => {
              this.$set(row, "switch", originalSwitch)
              this.$message.success(res.desc)
              this.selectCourseInfoPage()
            })
            .catch(err => {
              this.$set(row, "switch", !originalSwitch)
              this.$message.error(err.desc)
              this.selectCourseInfoPage()
            })
        })
        .catch(() => {
          this.$set(row, "switch", !originalSwitch)
          this.selectCourseInfoPage()
        })
    },
    // 上下架状态
    changeOnlineStatus(row) {
      const originalSwitch = row.onlineStatus
      this.$confirm(`确定${row.onlineStatus ? "上架" : "下架"}吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(this.$api.updateOnlineStatusCourse, {
              id: row.id,
              onlineStatus: row.onlineStatus ? 1 : 0,
            })
            .then(res => {
              this.$set(row, "onlineStatus", originalSwitch)
              this.$message.success(res.desc)
              this.selectCourseInfoPage()
            })
            .catch(err => {
              this.$set(row, "onlineStatus", !originalSwitch)
              this.$message.error(err.desc)
              this.selectCourseInfoPage()
            })
        })
        .catch(() => {
          this.$set(row, "onlineStatus", !originalSwitch)
          this.selectCourseInfoPage()
        })
    },
    // 新增 / 修改
    handleApply(row) {
      if (row == 1) {
        this.$router.push("/courseManage/detail/applyCourse")
      } else {
        this.$router.push({ path: "/courseManage/detail/applyCourse", query: { id: row.id } })
      }
    },

    // 删除
    handleDelete(row) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .get(this.$api.deleteCourseInfo, {
              params: { id: row.id },
            })
            .then(res => {
              if (res.code == 100) {
                this.$message.success(res.desc)
                this.selectCourseInfoPage()
              }
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        })
        .catch(() => {
          this.$message("取消删除")
        })
    },
    handleCheck(row) {
      this.$router.push({
        path: "/courseManage/detail/lesson",
        query: {
          id: row.id,
          costAttr: row.costAttr,
        },
      })
    },
    handleBuy(row) {
      this.$router.push({
        path: "/courseManage/detail/buyerList",
        query: {
          id: row.id,
          type: 1,
        },
      })
    },
    handleView(row) {
      this.$router.push({
        path: "/courseManage/detail/courseInfo",
        query: {
          id: row.id,
        },
      })
    },
    handleAfter(row) {
      this.$router.push({
        path: "/courseManage/detail/afterClassQA",
        query: {
          id: row.id,
          type: 0,
        },
      })
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 搜索
    onSearch() {
      this.clearData()
      this.selectCourseInfoPage()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.pageSize = e
      this.onSearch()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.selectCourseInfoPage()
    },
  },
}
</script>

<style lang="scss" scoped>
.main {}
</style>
